import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import App from "./App";
import "react-datepicker/dist/react-datepicker.css";
import "./breakpoints.css";
import "./styles.css";
import "./styles-shared-session.css";
import "./styles-applicant.css";
import "./styles-recruitment.css";
import "./styles-recruitment-redesign.css";
import "./styles-applicant-redesign.css";
import "./nd1/nd1.css";
import "./pitch-video-player-host.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
